<ion-header id="video-header" [translucent]="true">
  <ion-toolbar>
    <ion-avatar slot="start">
      <img *ngIf="embGroup" [src]="embGroup.image" />
    </ion-avatar>
    <div class="ml-2" style="line-height: 1.2rem;" *ngIf="t">
      <div class="training-title">{{t.title}}</div>
      <div class="training-desc ion-text-nowrap">{{t.description}}</div>
    </div>

    <div *ngIf="!isWeb()" style="margin-right: 8px;" slot="end">
      <ion-button (click)="modalController.dismiss()" fill="clear" color="dark">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </div>

  </ion-toolbar>
</ion-header>

<ion-content *ngIf="localData" [fullscreen]="true">
  @if (!t.instagram_url) {
  <div class="video-panel">
    @if(t.adv || t.adv_company) {
        <div class="adv-container">
          <div class="adv">
            <div class="adv-label">ADV</div>
          </div>
        </div>
        
      }
    <video id="main-video" preload="metadata" playsinline autoplay [controls]="hasControls()"
      (loadedmetadata)="loadedmetadata($event)" (timeupdate)="timeupdate()" (seeking)="seeking()" (seeked)="seeking()"
      (ended)="ended()" (play)="onplay()" (loadeddata)="loadeddata($event)" (pause)="onpause()" [poster]="t.cover"
      class="w-full">
      <source [src]="t.video_url" type='video/mp4' />
    </video>
    <div id="kp-panel" class="hidden">
      <div id="cancel-button" class="cancel-button hidden">
        <ion-button (click)="utils.stopFullscreen()" fill="clear">
          <ion-icon slot="icon-only" name="close"></ion-icon>
        </ion-button>
      </div>
    </div>

    <p-progress-bar [showValue]="false" [value]="progress"></p-progress-bar>
    <div class="controls flexh w-full">
      <ion-button fill="clear" (click)="play()">
        <ion-icon slot="icon-only" [name]="playIcon" />
      </ion-button>

      <ion-button fill="clear" color="dark" (click)="changeSpeed()">
        <ion-label>{{speedLabels[speedIndex].toUpperCase()}}</ion-label>
      </ion-button>

      <ion-button fill="clear" (click)="rewind()">
        <ion-icon class="rewind" slot="icon-only" name="play-back"></ion-icon>
      </ion-button>

      <ion-button fill="clear" (click)="begin()">
        <ion-icon slot="icon-only" name="play-skip-back"></ion-icon>
      </ion-button>

      <div *ngIf="tvideo" class="ml-auto title">{{utils.readableMinSec(tvideo.currentTime)}}</div>

      <ion-button fill="clear" (click)="utils.goFullScreen()">
        <ion-icon slot="icon-only" name="scan"></ion-icon>
      </ion-button>

    </div>

    <!-- Fullscreen View -->

  </div>
  }
  @else {
  <ig-embed [postUrl]="t.instagram_url"></ig-embed>
  }


  <p-accordion>
    <p-accordion-panel value="0">
      <p-accordion-header>
        <ng-template #toggleicon let-active="active">
          @if (active) {
          <i class="pi pi-minus" style="font-size: 0.9rem;"></i>
          } @else {
          <i class="pi pi-plus" style="font-size: 0.9rem;"></i>
          }
        </ng-template>
        <span class="flexh w-full">
          <div class="ml-auto mr-2">Più informazioni</div>
        </span>
      </p-accordion-header>
      <p-accordion-content>
        <div class="flexv" style="line-height: 1.55rem">
          <div class="training-title-large">{{t.title}}</div>
          <div class="training-desc-large">{{t.description}}</div>
        </div>
        <div class="flexv" style="gap:16px; margin-top:16px">
          <div class="flexh">
            <i class="pi pi-question" style="margin-right: 12px;"></i>
            <ion-label *ngIf="t.questions" style="font-size: 1.2rem;">{{t.questions.length}} domande</ion-label>
          </div>
          <div *ngIf="t.single_quest_score && t.questions" class="flexh">
            <i class="pi pi-trophy" style="margin-right: 12px;"></i>
            <!-- <ion-label style="font-size: 1.2rem;">{{t.single_quest_score*t.questions.length}}
              <small>PT</small></ion-label> -->
            <ion-label style="font-size: 1.2rem;">
              {{t.single_quest_score*t.questions.length}} <small>PT</small> {{ ((t.company_training_prize ? t.company_training_prize : 0)>0 && !isWeb())
              ? ' + ' + t.company_training_prize +' extra' : ''}}

            </ion-label>
          </div>
        </div>

      </p-accordion-content>
    </p-accordion-panel>

  </p-accordion>

  @if(!t.instagram_url) {
  <div class="title p-4">Contenuti</div>
  <div>
    <div (click)="seek(kp.begin)" class="kp-container" *ngFor="let kp of t.keypoint_data">
      <p-progress-bar [showValue]="false" [value]="kp.progress"></p-progress-bar>
      <div class="kp-label">{{kp.label}}</div>
      <div class="kp-time">{{utils.keypointDuration(kp)}}</div>
      <div *ngIf="kpdone(kp)" class="kp-checked">
        <i class="pi pi-check"></i>
      </div>
    </div>
  </div>
  }

</ion-content>

<ion-footer id="video-footer">
  <ion-button (click)="startQuiz()" id="quiz_button" expand="block" style="width: 100%;">
    <ion-label>INIZIA QUESTIONARIO</ion-label>
  </ion-button>
  <div style="height: 8px;" *ngIf="isWeb()"></div>
</ion-footer>

<ion-footer id="kp-panel-footer" class="hidden">
  <p-accordion>
    <p-accordion-panel value="0">
      <p-accordion-header>
        <div class="controls flexh">
          <ion-button fill="clear" (click)="play()">
            <ion-icon slot="icon-only" [name]="playIcon" />
          </ion-button>

          <ion-button fill="clear" color="dark" (click)="changeSpeed()">
            <ion-label>{{speedLabels[speedIndex].toUpperCase()}}</ion-label>
          </ion-button>

          <ion-button fill="clear" (click)="rewind()">
            <ion-icon class="rewind" slot="icon-only" name="play-back"></ion-icon>
          </ion-button>

          <ion-button fill="clear" (click)="begin()">
            <ion-icon slot="icon-only" name="play-skip-back"></ion-icon>
          </ion-button>

          <div *ngIf="tvideo" class="ml-auto title mr-2">{{utils.readableMinSec(tvideo.currentTime)}}</div>

        </div>
      </p-accordion-header>
      <p-accordion-content>
        <div (click)="seek(kp.begin)" class="kp-container" *ngFor="let kp of t.keypoint_data">
          <p-progress-bar [showValue]="false" [value]="kp.progress"></p-progress-bar>
          <div class="kp-label">{{kp.label}}</div>
          <div class="kp-time" style="color:grey">{{utils.keypointDuration(kp)}}</div>
          <div *ngIf="kpdone(kp)" class="kp-checked">
            <i class="pi pi-check white"></i>
          </div>
        </div>
      </p-accordion-content>
    </p-accordion-panel>
  </p-accordion>
</ion-footer>